import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BadgeStyled, IconStyled, SegmentedControlStyled, } from './segmented-control.styles';
/**
 * A component than can display some information including an icon and badge. Several of these can be grouped inside a `<SegmentedControl>` to create a useful toolbar.
 *
 * There are two main display variations:
 *
 * - the default is to display inline in the page
 * - `isElevated` to display over the top of other content (such as on the top of a map).
 */
export const SegmentedControl = ({ badge = null, isElevated = false, icon = null, onClick = () => null, text, variant = 'medium', highlight, }) => {
    return (_jsxs(SegmentedControlStyled, { highlight: highlight, "data-testid": Array.isArray(variant) ? variant.join('-') : variant, isElevated: isElevated, onClick: onClick, variant: variant, children: [icon && _jsx(IconStyled, { children: icon }), text, badge && _jsx(BadgeStyled, { children: badge })] }));
};
//# sourceMappingURL=segmented-control.js.map